export const setCuttingLinePathData = (self, path_data) => {
  self._checkNoProcessingTask();
  const cutting_line_clip_path_el = self._getCuttingLineClipPathElThrowable();
  const cutting_line_display_path_el =
    self._getCuttingLineDisplayPathElThrowable();
  const d = path_data.trim();
  if (!/[Zz]$/.test(d)) {
    throw new Error(`잘못된 패스입니다. 패스는 항상 닫혀 있어야 합니다.`);
  }
  if (!/^[mM]/.test(d)) {
    throw new Error(
      `잘못된 패스입니다. 패스는 항상 move to 명령어로 시작해야 합니다.`
    );
  }
  self._cutting_line_path_data = d;
  cutting_line_clip_path_el.setAttributeNS(null, "d", d);
  cutting_line_display_path_el.setAttributeNS(null, "d", d);
};
